import React, { useContext,useState ,useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import {
  casinoMainMenu,
  casinoMenu,
} from "../Utils/constants";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import FlagIcon from "../assets/icons/india-icon.png";
import FlagIconBn from "../assets/icons/bangladesh-flag-round-circle-icon.png";
import PromotionsIcon from "../assets/images/icon-promotion.webp";
import iconAffiliate from "../assets/images/icon-affiliate.png";
import HomeIcon from "../assets/images/icon-home.webp";
import iconTalk from "../assets/images/icon-member-talk.svg";
import iconTelegram from "../assets/images/icon-telegram.svg";
import iconAbous from "../assets/images/icon-abous-us.svg";
import iconFaq from "../assets/images/icon-faq.svg";
import logo from "../assets/images/logo.png";

const MenuSidebarNew = () => {

  let { logoutUser, setShowSidebar,lang ,user, setEn, setBr,launchEGTCasino,
    launchCasino,withoutLogin} = useContext(AuthContext);
  const navigate = useNavigate();
  const setFunc = (type) => {
    setData(
      casinoMenu?.find((res) => {
        {
          return res?.key == type;
        }
      })
    );
    setKey(type);
  };
  const [data, setData] = useState({});
  const [activeClass, SetActiveClass] = useState("");
  const [key, setKey] = useState("");
  useEffect(() => {
    // setData(
    //   casinoMenu?.find((res) => {
    //     {
    //       return res?.key == "sports";
    //     }
    //   })
    // );

    window.addEventListener('scroll', () => {
      
      if(window.scrollY > 180){
       
        SetActiveClass('gamefixed');
      }else{
        SetActiveClass('');
      }
      
   });

  }, []);
  const {t} = useTranslation()
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setShowSidebar(false);
      }}
    >
      <div>
        <div className="sidebar-wrapper">
          {/* <div className="top-sidebar mb-3 ps-1 d-flex justify-content-between align-items-center">
           
            <button
              className="bg-transparent border-0 p-0"
              onClick={() => setShowSidebar(false)}
            >
              <RxCross2 />
            </button>
          </div> */}
          {/* <div className="sponsor-representation">
      <img 
        alt="UI version logo" 
        className="sponsor-representation__logo" 
        src={logo}
        loading="lazy"
      />
      <div className="sponsor-representation__title">Front of Shirt Partner</div>
      <img 
        alt="Sponsor image" 
        className="sponsor-representation__sponsor" 
        src="https://img.b112j.com/bj/h5/assets/images/sponsor/afc-bournemouth.png?v=1739875429978&source=mcdsrc" 
        loading="lazy"
      />
    </div> */}
          <ul>
          <li><figure> <img src={"data:image/png;base64,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"} alt=""/></figure><Link to="/" className="text-decoration-none"> <span>{"Home"}</span></Link></li>
          {/* <li>
            <figure><img className="apply-specific-color" src={PromotionsIcon} alt=""/></figure>
            <Link to="/promotions" className="text-decoration-none">
              <span> Promotions </span>
            </Link>
          </li> */}
          </ul>
          <ul>
            <div className="title">Games</div>
        {casinoMainMenu?.map((item,index) => {
          return (
            <li key={index}  onClick={() => {setFunc(item?.type); }}className={`${key == item?.type ? "active" : ""}`}>
              <figure><img src={item?.icons} alt=""/></figure>
              <a className="text-decoration-none"> <span>{lang == "bn" ? item?.titlebn : item?.title}</span></a>
          </li>
          );
        })}
        </ul>
        <div className="title">Others</div>
        <ul>
          {/* <li> <figure><img src={iconTalk} alt=""/></figure><Link to="#" className="text-decoration-none">   24/7 Live Chat  </Link></li> */}
          {/* <li> <figure><img src={iconTelegram} alt=""/></figure><Link to="#" className="text-decoration-none"> Telegram Support  </Link></li> */}
          <li> <figure><img src={"data:image/png;base64,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"} alt=""/></figure><Link to="https://www.facebook.com/share/g/1Ew9nHVZ5x/" className="text-decoration-none">   Facebook  </Link></li>
          <li> <figure><img src={"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAs1QTFRFAAAAAFZBGmqgVpLHm77e0+Lw9fn8/////f7+2+jzqMfiY5rMLHa5A1hPu9Pp+fv96fH4mb3deKfSZJvMWZTIWJPIcqTQjrbass3m3ur0z+DvfKrUKXS4O4C/r8vlytztd6fSOoC+CFxlMHm7ap7Ot9DnydztaZ7O3On0bKDPJnK3EmSJvtXq7/X6hbDXg6/W9/r8nsDfK3a5e6nT9vn8+/z+osPggq7WeqnTVJDH5O72pMThYZnLcaPQUo/G6vL4i7TZNHy83en0ga3V8/f7XJbJp8bisc3lkbjb1eTxHWyoP4PA/v7/7fP5Q4bBKHS4nL/eo8Th/P3+L3m78fb6RofCBFlWOH++a5/OC19zXZbKZ53N0uLwDmF7irTZ5u/3s87mNX29bqHPrcrkpsXiVZHHWpTJAVdIf6zVyNvtjLXZxNnr6/L4h7LYbaDP2efz4ez1Lni6YpnL9Pj75/D3+vz9eajTudLo4uz2MXq77vT5n8HfQYTB8vf7qcfjT43Fb6LPzN7uIG6v5e73favUJHG3zt/vEGKCpcXhN369S4vEdKXRrsvkPIG/SorDJIh6RbNIWc4pYdgdatM/3/LgbKDOcKLQA1pSTr86oeh5+/757/voaslZ4Ov1BFxXWc0pdd063PbMs+ySY9khsMzlocLgreuK/v/+e95CTb47jONa8PvqqeqEYtgeI4Z7dabRRrVFf99I4vjVyfKybdsuRrVGk7ncWs4ohOFP4fjU0/TAV8otc6TRZNkhl+Vq6/ri1/XGXtQimr7e0ODvJ3O4g+BOvO6fyvK0ed4/8PX6TIvEteG17Prkq+qHbNstRrRGxtrsIW+2PYK/rMnkSYnDLXe6KnW5xPCqguBNV5LIttDn7PP53+v16PD4j7fZds5natoqM3u8mL3dtc/nx9vs0eHwutLoAllMOX++BV5cT8A5I4Z8RLJJQ7FKIoV8MJXJ2AAAAO90Uk5TAP////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+1gsVQAAADw0lEQVR4nMXXf0xVZRgH8OeraSLCWogwByPUsSAmak1RvIUuFJldKEejko2BP6gk5rChjEktCyphIYoORd1iaotFiyGSiSBOMuZqOgdpRdBCxlBSEK9I3t5z7zmHe855DlzCzfPHe57n2fu558d9z3veA2I36HK7W73Maqw3duQpy/VdzSnDMUo2Jodp4oaGSeyWBhO5zWEIxqGh249LPwo8Pqto/C8ra7AWjs01uctpDs94OBk2D9GIbdBTNLfIB/ibxzobgNs2f0HalcIcoJOC+noN2ohDOh8GA62aWlhb6PUQXGGw1s5Haxh+1l8hhU0T59Lb7lqyG/DiX6aFXjRQaYvEpRcu6LHGRg084XGetUQW/Li0UaO1OBr93vUmlmj60vOWH8xxTGP0hQFTTKvPrkStK3a1ceKmVJtbsg7VL3a9KA2Or437dhRLNHvJvTrXycAFv9br23BTzYKfx9dq8jpwQuwWDravO87jNysTUaFmyeIajsrxs78lH3EEqRXJ5Tx+ajD6ezXZ0NJKKwMPSqFnxF2/Z8oc1c1HV5zicfrhtP1KvCb4kGg3Yi9RBg68jS+c5a1AIY8zp+BzJX6/2LF7b1JFTJUNAb/L5ciBp8/xOPvf8j453N51YqROb5xTBrVl+Z19PH6rMkR5cHJ20xZb2SRnEhL/sfozc0tu8zjhZPZHzmhnQUxg/TXPzBrHk7ngJ7VLkO+yPTzOy8/5wBF82LwMyJUq7eLs85CjdsnP8/uLxwWnPSzZUvAZsM1ZKizutsxyDosix1yWVbSFx2IIrKiT9gHL1du1MCr0XWlfiiHRPin4g3d4XLijdNefxG3l6BetNzYdxLBN1RpMX6YdXs/i/dJxaSYGvHrIL4nHr0RcnfoVY4smS60/hqdIM3DAOgVrp6FvPlly/5ARV3WKJgiJlfhDBHPXOqu6mYSo5tWsjmMGfPK6GCqwVnfdkbLQVSaY4k+FF8TocTE9B8TWdfc4sohoFet146rTsOiP7I2OlAbII00+snHeJvr0pTO5dkq5OPLOmHEGiKqYA2X6siwawTq9oS9XDIXMpnxbAhKpsrbl1yPJ10osGJknnHebfVe1/VOVWlbi0RJOWYOXqQxJl+fP3Ad8p3aQ/2c794p9edeLlN4wryi2TpxAdlNzgnX6NnvpkNrHK3a2bBl8ozvOmhHujNeHKQ9UN+ThnmT3Jw12a1nRg+p+Lyt8SLWPYkHzGNdhE1s+Tmzh6jZnl8xuarPF+sQ+E8bko36gjM7H/DQy5259lLFl/nPwP+pKF1wPcT12AAAAAElFTkSuQmCC"} alt=""/></figure><Link to="#" className="text-decoration-none">   Monthly Lottery </Link></li>
          {/* <li> <figure><img src={iconFaq} alt=""/></figure><Link to="#" className="text-decoration-none">   FAQ  </Link></li> */}

        </ul>
       
        <ul>
        
        {!isEmpty(user) ? (
          <>
          <li className="language-select">
          <div
            className="language-select-div"
            onClick={() => {
             
              setBr();
              
            }}
          >
            <img src={FlagIconBn} alt="" />{" "}
            <p>বাংলা</p> 
          </div>
          <div
            className="language-select-div"
            onClick={() => {
              
                setEn();
              
            }}
          >
            <img src={ FlagIcon } alt="" />{" "}
            <p>English</p>
          </div>
        </li>
            
          </>):("")}</ul>
         
           
        </div>
        {
          key!="" &&
          <div class="menu-second">
          <ul class="menu-second-ul active">
          {data?.array?.map((res) => {
              return (
                  <li class=""   
                    onClick={() => {
                    if (!isEmpty(user)) {
                      if (data?.key == "exchange") {
                        window.open(res?.link, "_self");
                      } else {
                        if (!isEmpty(user)) {
                          if (res?.gameTypeCheck == "platForm") {
                            launchCasino({
                              platForm: res?.platForm,
                              gameType: res?.gameType,
                              casinoType: res?.casinoType,
                            });
                          } else if (res?.gameType == "egtGame") {
                            launchEGTCasino({
                              platForm: res?.platForm,
                              gameType: res?.gameTypeNew,
                              casinoType: res?.casinoType,
                            });
                          } else if (!isEmpty(res?.gameid)) {
                            launchEGTCasino({
                              platForm: res?.platForm,
                              gameType: res?.gameType,
                              casinoType: res?.casinoType,
                              gameid: res?.gameid,
                            });
                          } else {
                            if (
                              res?.platForm !== "" &&
                              res?.gameType !== "" &&
                              res?.casinoType !== ""
                            ) {
                              launchCasino({
                                platForm: res?.platForm,
                                gameType: res?.gameType,
                                casinoType: res?.casinoType,
                              });
                            }
                          }
                        } else {
                          navigate("/login");
                        }
                      }
                    } else {
                      withoutLogin()
                    }
                  }}>
                  <figure><img src={res?.image} alt=""/></figure><p>{res?.title}</p>
                  </li>
              );
            })}
        </ul>
      </div>
        }
       
      </div>
      
    </OutsideClickHandler>
  );
};

export default MenuSidebarNew;
